import Image from 'next/legacy/image';
import { FC, useState } from 'react';
import Link from 'next/link';
import {
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
  MdOutlineMenu,
  MdOutlineMenuOpen,
} from 'react-icons/md';

import { getDoctorName, GlobalHeaderProps, IDSNavigation, Styled } from '.';
import { useComponentVisible } from 'utils/hooks';
import { useI18n } from 'contexts/i18n';

const GlobalHeader: FC<GlobalHeaderProps> = ({
  tabs,
  profileLinks,
  doctorName,
  pcUserName,
  impersonator,
}) => {
  const i18n = useI18n();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const docName = getDoctorName(pcUserName, impersonator, doctorName);
  const translatedDocName = i18n['doctorName']?.replace('{docName}', docName);
  const {
    ref: drProfileRef,
    isComponentVisible: showDrProfileMenu,
    setIsComponentVisible: setShowDrProfileMenu,
  } = useComponentVisible(false);

  const onMenuItemClick = (link: string) => {
    if (link === '/logout') {
      sessionStorage.clear();
    }
    window.location.href = link;
    setShowDrProfileMenu(false);
  };

  const onMobileMenuItemClick = (state: boolean) => {
    setIsMobileMenuOpen(previousState => !state);
  };

  return (
    <>
      <Styled.GlobalHeaderContainer>
        <Styled.GlobalHeaderWrapper>
          <Styled.MobileMenuIcon
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <MdOutlineMenuOpen size="24px" />
            ) : (
              <MdOutlineMenu size="24px" />
            )}
          </Styled.MobileMenuIcon>
          <Link href="/" passHref>
            <Image
              src="/images/invisalignLogo.svg"
              alt="Invisalign"
              height={74}
              width={223}
            />
          </Link>

          <div style={{ display: 'flex' }}>
            <Styled.DoctorMenuLink>
              <Styled.DoctorName>
                {`${i18n['Hello']}, ${translatedDocName}`}
              </Styled.DoctorName>

              <Styled.DoctorMenu
                onClick={() => setShowDrProfileMenu(!showDrProfileMenu)}
                ref={drProfileRef}
              >
                <Image
                  src="/images/doctorProfile.png"
                  alt="DoctorProfileImage"
                  height={30}
                  width={30}
                />
                {showDrProfileMenu ? (
                  <MdKeyboardArrowUp size="32px" color="white" />
                ) : (
                  <MdKeyboardArrowDown size="32px" color="white" />
                )}
                {showDrProfileMenu && (
                  <Styled.Menu right="0px">
                    {profileLinks.map(profileLink => (
                      <Styled.MenuItem
                        key={profileLink.link}
                        onClick={() => onMenuItemClick(profileLink.link)}
                      >
                        {i18n[profileLink.label]}
                      </Styled.MenuItem>
                    ))}
                  </Styled.Menu>
                )}
              </Styled.DoctorMenu>
            </Styled.DoctorMenuLink>
          </div>
        </Styled.GlobalHeaderWrapper>
      </Styled.GlobalHeaderContainer>
      <IDSNavigation
        onMobileMenuItemClick={onMobileMenuItemClick}
        isMenuOpen={isMobileMenuOpen}
        tabs={tabs}
      />
    </>
  );
};

export default GlobalHeader;
